/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Rankings_Page_InfoInputs */



/**
* | output |
* | --- |
* | "{current} / {total}" |
*
* @param {Rankings_Page_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rankings_page_info = /** @type {((inputs: Rankings_Page_InfoInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rankings_Page_InfoInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.current} / ${i?.total}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.current} / ${i?.total}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.current} / ${i?.total}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.current} / ${i?.total}`)
	return /** @type {LocalizedString} */ (`${i?.current} / ${i?.total}`)
});